import { Image, Stack } from '@superdispatch/ui';
import { Link, Typography } from '@material-ui/core';
import {
  FormikRadioCardField,
  FormikRadioGroupField,
} from '@superdispatch/forms';
import autoHauler from '../assets/auto-hauler.png';
import autoHaulerDark from '../assets/auto-hauler-dark.png';
import towaway from '../assets/towaway.png';
import towawayDark from '../assets/towaway-dark.png';
import driveaway from '../assets/driveaway.png';
import driveawayDark from '../assets/driveaway-dark.png';
import styled from 'styled-components';

const Illustration = styled(Image)`
  width: 144px;
`;

interface TransportationTypeFieldProps {
  disabled?: boolean;
}

export function TransportationTypeField({
  disabled,
}: TransportationTypeFieldProps) {
  return (
    <Stack space="small">
      <Typography variant="h4">Transport Type</Typography>
      <FormikRadioGroupField
        name="logistics_type"
        fullWidth={true}
        disabled={disabled}
      >
        <Stack space="small">
          <FormikRadioCardField
            name="logistics_type"
            value="auto_hauler"
            label="I’m an Auto-Hauler"
            caption="I transport multiple vehicles at once using a truck or trailer."
            icon={<Illustration src={autoHauler} srcDark={autoHaulerDark} />}
          />
          <FormikRadioCardField
            name="logistics_type"
            value="towing"
            label="I’m a Towaway"
            caption="I tow a single vehicle or trailer by towing it to its destination."
            icon={<Illustration src={towaway} srcDark={towawayDark} />}
          />
          <FormikRadioCardField
            name="logistics_type"
            value="driveaway"
            label="I’m a Driveaway"
            caption="I deliver one vehicle by driving it directly to the customer."
            icon={<Illustration src={driveaway} srcDark={driveawayDark} />}
          />
        </Stack>
      </FormikRadioGroupField>
      <Typography color="textSecondary">
        Unsure what to select?{' '}
        <Link
          href="https://support.superdispatch.com/hc/en-us/articles/43820006778259-How-to-Choose-Your-Transport-Type"
          target="_blank"
          rel="noreferrer"
          color="primary"
        >
          Click here to learn more
        </Link>
      </Typography>
    </Stack>
  );
}
